import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetUserPersonalizationDataTypes } from "../../../../Schema/getUserPersonalization.types";

export type GetUserPersonalizationLoadAction = {
    type: string;
};

export type GetUserPersonalizationData = {
    data: {
        message:string
        data:GetUserPersonalizationDataTypes
    };
};

const GetUserPersonalization = new ReduxFetchState<GetUserPersonalizationData, { id?: number | string;getUserPersonalization_token: string  }, any>(
    "getUserPersonalization",
);

export function* watchGetUserPersonalization(action: GetUserPersonalizationLoadAction) {
    try {
        const lang: "fa" | "en" = yield getCurrentLanguage();
        const data: GetUserPersonalizationData = yield axios({
            url: `/api/v1/ai/user/personalization`,
            method: "GET",
            headers: { lang },
        });

        yield put(GetUserPersonalization.actions.loadSuccess({ data: data.data }));
    } catch (e: any) {
        const backendError = e?.response?.data?.error || e?.message || "Something went wrong";
        alert({ message:backendError, type: "error" });
        yield put(GetUserPersonalization.actions.loadFailure(e.message));
    }
}

export function* getUserPersonalizationSagas() {
    yield takeEvery(GetUserPersonalization.actionTypes.load, watchGetUserPersonalization);
}

export function useGetUserPersonalization() {
    const { loading, data, ...getUserPersonalizationState } = useAppSelector(
        (state) => state.getUserPersonalization,
    );
    const dispatch = useAppDispatch();

    const dispatchGetUserPersonalization = useCallback(
        () => {
            dispatch(GetUserPersonalization.actions.load());
        },
        [dispatch],
    );

    return {
        ...getUserPersonalizationState,
        dispatchGetUserPersonalization,
        getUserPersonalizationLoading: loading,
        getUserPersonalizationData: data,
    };
}

export const {
    actionTypes: getUserPersonalizationActionsTypes,
    actions: getUserPersonalizationActions,
    reducer: getUserPersonalizationReducer,
} = GetUserPersonalization;
